var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "500",
        "content-class": "player-props-widget-dialog",
        persistent: ""
      },
      model: {
        value: _vm.playerPropsData,
        callback: function($$v) {
          _vm.playerPropsData = $$v
        },
        expression: "playerPropsData"
      }
    },
    [
      _c("div", { staticClass: "close-btn" }, [
        _c("button", {
          staticClass: "close",
          domProps: { innerHTML: _vm._s(_vm.$t("PlayerProps.Widget.Close")) },
          on: { click: _vm.closePlayerPropsDialog }
        })
      ]),
      _vm._v(" "),
      _vm.playerPropsData && _vm.playerPropsData.markets[0].selections
        ? _c(
            "v-card",
            { staticClass: "player-props-w" },
            [
              _c("player-props-widget", {
                attrs: { isDialog: true, event: _vm.playerPropsData }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fcd6419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fcd6419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsDialog.vue
// module id = null
// module chunks = 